export default __webpack_public_path__ + "static/media/TechPack.a1b95a0f.svg";